import React from 'react';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import AppLayout from '../../components/layout/AppLayout';
import QueueDashboard from '../../components/queue/QueueDashboard';

const QueueDashboardPage: React.FC = () => {
  return (
    <AppLayout>
      <Box>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 3 }}>
          <Link 
            component={RouterLink} 
            to="/dashboard" 
            color="inherit" 
            underline="hover"
          >
            Dashboard
          </Link>
          <Typography color="text.primary">Queue Dashboard</Typography>
        </Breadcrumbs>

        <QueueDashboard autoRefreshInterval={30} />
      </Box>
    </AppLayout>
  );
};

export default QueueDashboardPage;